import { ActionTree } from "vuex";
import { Recipes } from "@/types/recipes";
import {
  HomeState,
  RootState,
  InformationServices,
  Banners,
  FavoriteRecipeClips,
  RequestFoodsRecommendationList,
  RequestOneMenuRecommendation,
  RequestRecommendationRecipe
} from "@/types/home";
import store from "@/store";
import apiClient from "@/client/api-client";
import { getApplianceListText } from "@/utils/search-util";
import { API_URL_INFORMATON, API_URL_MENU, API_URL_RECIPE } from "@/const/api-const";
import NativeClient from "@/client/native-client";

const getFoodListText = (foodList: Array<string> | null) => {
  let foodListText = "";
  if (foodList != null) {
    foodList.forEach(foodId => {
      if (foodListText != "") {
        foodListText += " ";
      }
      foodListText += foodId;
    });
  }
  return foodListText;
};

const actions: ActionTree<HomeState, RootState> = {
  getRecommendRecipes: async ({ commit }, payload: RequestRecommendationRecipe | null) => {
    NativeClient.sendDebugLog(
      "getRecommendRecipes payload = " + JSON.stringify(payload)
    );
    // Nativeから受け取った認証関連パラメータを取得
    const apiParams = store.getters["common/getApiBaseParams"];
    const recipes: Recipes | null = store.getters["home/getRecommendRecipes"];
    NativeClient.sendDebugLog(
      "getRecommendRecipes apiParams=" + JSON.stringify(apiParams)
    );
    NativeClient.sendDebugLog(
      "getRecommendRecipes exist recipes =" + JSON.stringify(recipes)
    );
    // すでに全件取得済みの場合はなにもしない
    if (recipes && recipes.recipes && !(payload != null && payload!.isRefresh)) {
      if (recipes.totalCount <= recipes.recipes.length) {
        NativeClient.sendDebugLog(
          "getRecommendRecipes no effect"
        );
        return;
      }
    }
    const foodList = (payload) ? payload.foodList : null; 
    const foodListText = getFoodListText(foodList);
    const applianceText = getApplianceListText(apiParams.applianceList);
    // レシピ検索API呼び出し
    // personalizedOptionは、"pantryBase useHistory"に固定
    const personalizedOption = "pantryBase useHistory";
    let isRefresh = false;
    if (payload != null && payload!.isRefresh) {
      isRefresh = true;
    }
    let productId = applianceText;
    if (productId == null) {
      productId = "NO_APPLIANCE"
    } else {
      productId += " ";
      productId += "NO_APPLIANCE";
    }
    const res = await apiClient.get(API_URL_RECIPE.SEARCH, {
      params: {
        // My家電ID
        myAppliance: applianceText != null ? applianceText : null,
        // ProductId
        productId: productId,
        // 取得開始位置（すでに取得済みの場合、取得した件数以降の開始位置を指定）
        start: 0,
        // 取得件数は 9 件固定
        row: 10,
        // 食材ID
        foodId: foodListText != "" ? foodListText : null,
        // 検索結果のソート順：一致
        order: "personalized",
        // 提案アルゴリズムの指定
        personalizedOption: personalizedOption,
        // リフレッシュ
        refresh: isRefresh,
        scene: "auto"
      }
    });
    NativeClient.sendDebugLog(
      "getRecommendRecipes response = " + JSON.stringify(res.data)
    );
    commit("updateRecommendRecipes", res.data);
  },
  getRankingRecipes: async ({ commit }) => {
    // Nativeから受け取った認証関連パラメータを取得
    const apiParams = store.getters["common/getApiBaseParams"];
    const recipes: Recipes | null = store.getters["home/getRankingRecipes"];
    NativeClient.sendDebugLog(
      "getRankingRecipes apiParams=" + JSON.stringify(apiParams)
    );

    // すでに全件取得済みの場合はなにもしない
    if (recipes && recipes.recipes) {
      if (recipes.totalCount <= recipes.recipes.length) {
        return;
      }
    }
    const applianceText = getApplianceListText(apiParams.applianceList);
    // レシピ検索API呼び出し
    const res = await apiClient.get(API_URL_RECIPE.RANKING, {
      params: {
        // My家電ID
        myAppliance: applianceText != null ? applianceText : null,
        // 取得開始位置（すでに取得済みの場合、取得した件数以降の開始位置を指定）
        start: 0,
        // 取得件数は 10 件固定
        row: 10
      }
    });

    commit("updateRankingRecipes", res.data);
  },
  updateBannerPosition: async ({ commit }, position: number) => {
    commit("updateBannerPosition", position);
  },
  updateInformationServices: async (
    { commit },
    list: InformationServices | null
  ) => {
    commit("updateInformationServices", list);
  },
  updateBanners: async ({ commit }, list: Banners | null) => {
    commit("updateBanners", list);
  },
  getBanners: async ({ commit }) => {
    // Nativeから受け取った認証関連パラメータを取得
    const banners: Banners | null = store.getters["home/getBanners"];

    // レシピ検索API呼び出し
    const res = await apiClient.get(API_URL_INFORMATON.BANNER);

    // TODO:更新日時を確認して更新する
    commit("updateBanners", res.data);
  },
  getInformationServices: async ({ commit }) => {
    // Nativeから受け取った認証関連パラメータを取得
    const banners: Banners | null =
      store.getters["home/getInformationServices"];

    // レシピ検索API呼び出し
    const res = await apiClient.get(API_URL_INFORMATON.SERVICE);

    // TODO:更新日時を確認して更新する
    commit("updateInformationServices", res.data);
  },
  // お気に入り一覧取得（トップ用、最近追加したもの）
  getRecentMyList: async ({ commit }) => {
    // お気に入りレシピ取得API呼び出し
    const apiParams = store.getters["common/getApiBaseParams"];
    const applianceText = getApplianceListText(apiParams.applianceList);
    const res = await apiClient.get(API_URL_RECIPE.MYLIST, {
      params: {
        // My家電ID
        myAppliance: applianceText != null ? applianceText : null,
        // 「ホーム > マイリスト」画面と「お気に入りを追加 > マイリストから選ぶ」 の画面で、表示するレシピを出し分けるために利用するパラメータ。
        needDlMenuId: false,
        // 取得開始位置（すでに取得済みの場合、取得した件数以降の開始位置を指定）
        start: 0,
        // 10件
        row: 10
      }
    });
    NativeClient.sendDebugLog(
      "getRecentMyList res=" + JSON.stringify(res.data)
    );
    commit("updateRecentMyList", res.data);
  },
  updateMyList: async ({ commit }, chips: FavoriteRecipeClips | null) => {
    commit("updateMyList", chips);
  },
  // お気に入り一覧取得（追加読み込み）
  getMyList: async ({ commit }) => {
    // お気に入りレシピ取得API呼び出し
    const apiParams = store.getters["common/getApiBaseParams"];
    const clips: FavoriteRecipeClips | null = store.getters["home/getMyList"];

    if (clips && clips.clips) {
      if (clips.totalCount <= clips.clips.length) {
        return;
      }
    }
    const applianceText = getApplianceListText(apiParams.applianceList);
    const start = clips && clips.clips ? clips.clips.length : 0;
    const res = await apiClient.get(API_URL_RECIPE.MYLIST, {
      params: {
        // My家電ID
        myAppliance: applianceText != null ? applianceText : null,
        // 「ホーム > マイリスト」画面と「お気に入りを追加 > マイリストから選ぶ」 の画面で、表示するレシピを出し分けるために利用するパラメータ。
        needDlMenuId: false,
        // 取得開始位置（すでに取得済みの場合、取得した件数以降の開始位置を指定）
        start: start,
        // 10件
        row: 10
      }
    });
    NativeClient.sendDebugLog("getMyList res=" + JSON.stringify(res.data));
    commit("updateMyList", res.data);
  },
  getFoodRecommendationList: async ({ commit }, parameter: RequestFoodsRecommendationList) => {
    const res = await apiClient.get(API_URL_RECIPE.FOODS_RECOMMENDATION, {
      params: {
        pattern: "auto",
        row: 2,
        latestRecommended: parameter.latestRecommended,
        refresh: parameter.isRefresh
      }
    });

    NativeClient.sendDebugLog(
      "Acrtion.ts getFoodRecommendationList res.data = " +
        JSON.stringify(res.data)
    );

    // 保存する
    commit("updateFoodRecommendationList", res.data);
  },
  getOneMenuRecommendation: async ({ commit }, payload: RequestOneMenuRecommendation | null) => {
    const foodList = (payload) ? payload.foodList : null; 
    const foodListText = getFoodListText(foodList);

    const res = await apiClient.get(API_URL_MENU.ONE_MENU_RECOMMEDATION, {
      params: {
        date: payload != null ? payload.date : null,
        pattern: "auto",
        refresh: payload != null ? payload.refresh : false,
        row: 1,
        foodId: foodListText != "" ? foodListText : null
      }
    });

    NativeClient.sendDebugLog(
      "Acrtion.ts getOneMenuRecommendation res.data = " +
        JSON.stringify(res.data)
    );

    // 保存する
    commit("updateOneMenuRecommendation", res.data);
  },
};

export default actions;
